import { getBannerMetadata } from './get-banner-metadata';

export const getClippingHelpers = () => ({
  getBannerMetadata
});
